/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardMensaDTO { 
    /**
     * Studenti serviti = ServizioMensaStudente non sospesi nello scope
     */
    famiglie_servite?: number;
    portafogli_sospesi?: number;
    /**
     * Incassi ricariche PAGATA per mese (chiave = mese 1..12), anno corrente
     */
    incassi_per_mese?: { [key: string]: number; };
}

